import { jsx as r } from "react/jsx-runtime";
import l from "clsx";
const c = (t) => l(t), s = "dds-validation-message-v0142";
function p({
  children: t,
  className: o = "",
  id: a,
  invalid: e = !1,
  ...i
}) {
  const n = {
    [s]: !0,
    [o]: o.length > 0,
    [`${s}--${e ? "invalid" : "valid"}`]: !0
  };
  return /* @__PURE__ */ r("p", { id: a, className: c(n), ...i, children: t });
}
export {
  p as ValidationMessage
};
//# sourceMappingURL=index.js.map
